import React, { lazy } from 'react';
import Launcher from '@/components/Launcher';

const NotFound = () => <Launcher type="404" />;

// 账户
const Account = lazy(() => import('@/pages/Account'));

// 欢迎
const Welcome = lazy(() => import('@/pages/Welcome'));
// 店铺
const ShopAgent = lazy(() => import('@/pages/Shop/Agent'));
const ShopAgentSettle = lazy(() => import('@/pages/Shop/Agent/LogisticsSettle'));
const ShopAgentRuleAdd = lazy(() => import('@/pages/Shop/Agent/Add'));
const ShopAgentRuleEdit = lazy(() => import('@/pages/Shop/Agent/Edit'));
// 硬件-硬件管理
const HardwareManage = lazy(() => import('@/pages/Hardware/Manage'));
const HardwareManageEdite = lazy(() => import('@/pages/Hardware/Manage/Edite'));
//  硬件-设备绑定管理
const HardwareBinding = lazy(() => import('@/pages/Hardware/Binding'));
const HardwareBindingEdite = lazy(() => import('@/pages/Hardware/Binding/Edite'));
//  硬件-广告管理
const Advertisement = lazy(() => import('@/pages/Hardware/Advertisement'));
const AdvertisementEdite = lazy(() => import('@/pages/Hardware/Advertisement/Edite'));
// 业务
// 业务-商户管理
const ShopBrand = lazy(() => import('@/pages/Business/Shop/Brand/List'));
const ShopBrandItem = lazy(() => import('@/pages/Business/Shop/Brand/Item'));
const ProductionItem = lazy(() => import('@/pages/Business/Shop/Store/maxProductionDetail'));
// const BusinessShopMerchant = lazy(() => import('@/pages/Business/Shop/Merchant'));
const ShopPolymerManage = lazy(() => import('@/pages/Business/Shop/Store')); // 门店管理 原店铺入驻
const ShopLicense = lazy(() => import('@/pages/Business/Shop/Qualifications')); // 门店资质 原申请管理
const ShopLicenseItem = lazy(() => import('@/pages/Business/Shop/Qualifications/components/Item'));
const ShopLicenseResraurant = lazy(
  () => import('@/pages/Business/Shop/Qualifications/components/RestaurantDetail'),
);
const ShopLicenseDetail = lazy(
  () => import('@/pages/Business/Shop/Qualifications/components/QualificationManageDetail'),
);
const ShopLicenseStore = lazy(
  () => import('@/pages/Business/Shop/Qualifications/components/StoreQualificationDetail'),
);
const ShopHardWareList = lazy(() => import('@/pages/Business/Shop/Store/components/HardWareList'));
const ShopBindHardWare = lazy(() => import('@/pages/Business/Shop/Store/components/BindHardWare'));
const ShopScore = lazy(() => import('@/pages/Business/Shop/Score'));
const ShopComplaint = lazy(() => import('@/pages/Business/Shop/Complaint'));
// 零食柜管理
const SnackCabinet = lazy(() => import('@/pages/Business/Shop/SnackCabinet'));
const SnackCabinetDetail = lazy(
  () => import('@/pages/Business/Shop/SnackCabinet/SnackCabinetDetail'),
);
// 业务-企业管理
const Enterprise = lazy(() => import('@/pages/Business/Company/Manage/List'));
const Research = lazy(() => import('@/pages/Business/Company/Manage/Research'));
const EnterpriseEdit = lazy(() => import('@/pages/Business/Company/Manage/Edit'));
const Allowance = lazy(() => import('@/pages/Business/Company/Allowance/index'));

// 企业管理 ssptodo

const ShopAdvertisement = lazy(() => import('@/pages/Shop/Advertisement/List'));
const ShopAdvertisementItem = lazy(() => import('@/pages/Shop/Advertisement/Item'));
const UserAccount = lazy(() => import('@/pages/Business/Company/UserAccount'));

// 新增订单列表项
const OptOrderList = lazy(() => import('@/pages/OptOrder/List'));
const OptOrderDetail = lazy(() => import('@/pages/OptOrder/Detail'));
const OptOrderExpress = lazy(() => import('@/pages/OptOrder/ModifyOrder/ExpressInfo'));
const CardOrder = lazy(() => import('@/pages/CardOrder/List'));
const TsOrder = lazy(() => import('@/pages/TsOrder/'));
const TsOrderDetail = lazy(() => import('@/pages/TsOrder/Detail'));
const SupplementOrder = lazy(() => import('@/pages/OptOrder/Supplement'));
const LiveMealStatistics = lazy(() => import('@/pages/OptOrder/LiveMealStatistics'));
const ShopToPayOrder = lazy(() => import('@/pages/OptOrder/ShopToPayOrder'));
const ShopToPayOrderDetail = lazy(() => import('@/pages/OptOrder/ShopToPayOrder/detail'));
const SupplementOrderItem = lazy(() => import('@/pages/OptOrder/Supplement/ItemPage'));
const ActivityOrder = lazy(() => import('@/pages/OptOrder/ActivityOrder'));
const AddOrder = lazy(() => import('@/pages/OptOrder/AddOrder'));
//  订单管理-售后订单
const AfterOrder = lazy(() => import('@/pages/OptOrder/After'));

// 客户
const CustomerAccount = lazy(() => import('@/pages/Customer/CustomerAccount'));
const CustomerAccountDetail = lazy(
  () => import('@/pages/Customer/CustomerAccount/CustomerAccountDetail'),
);
const CustomerAbutment = lazy(() => import('@/pages/Customer/Abutment'));

const MerchantShop = lazy(() => import('@/pages/Business/Shop/Store'));
const MerchantShopPatrol = lazy(() => import('@/pages/Business/Shop/Store/Patrol')); // 巡检
const MerchantMange = lazy(() => import('@/pages/Merchant/Manage'));
const MerchantEdit = lazy(() => import('@/pages/Merchant/Manage/Add'));
const ContractInfoForm = lazy(
  () => import('@/pages/Merchant/Manage/Edit/Components/ContractManage/Components/Add'),
);
const HistoryContractInfoForm = lazy(
  () => import('@/pages/Merchant/Manage/Add/Components/ContractManageHistory/index'),
);
const NewContractInfoForm = lazy(
  () => import('@/pages/Merchant/Manage/Add/Components/ContractManage/add'),
);
const EnterpriseManage = lazy(() => import('@/pages/Customer/Enterprise'));
const EnterpriseManageEdit = lazy(() => import('@/pages/Customer/Enterprise/Edit'));
const EnterpriseAddNewContract = lazy(
  () => import('@/pages/Customer/Enterprise/Edit/Components/ContractManage/Components/Add'),
);
const MerchantValuation = lazy(() => import('@/pages/Merchant/ValuationNew'));
const MerchantValuationAdd = lazy(() => import('@/pages/Merchant/ValuationNew/Add'));
// 营销
const MarketingManage = lazy(() => import('@/pages/Marketing/Manage'));
// 营销 - 返利记录
const MoneyRecord = lazy(() => import('@/pages/Marketing/MoneyRecord'));
const RecordManage = lazy(() => import('@/pages/Marketing/RecordManage/index'));
const RecordManageAdd = lazy(() => import('@/pages/Marketing/RecordManage/Add'));
// 营销 - 红包活动
const RedPacketManage = lazy(() => import('@/pages/Marketing/RedPacketManage/index'));
const RedPacketManageAdd = lazy(() => import('@/pages/Marketing/RedPacketManage/add'));
const RedPacketManageEditTarget = lazy(
  () => import('@/pages/Marketing/RedPacketManage/ActivityTarget'),
);
// 营销 - 新人福利
const NewWelfareList = lazy(() => import('@/pages/Marketing/NewWelfare/List'));
const NewWelfareAdd = lazy(() => import('@/pages/Marketing/NewWelfare/Add'));
// 营销 - 任务中心
const TaskCenterList = lazy(() => import('@/pages/Marketing/TaskCenter/List'));
const TaskCenterDetail = lazy(
  () => import('@/pages/Marketing/TaskCenter/components/TaskDetail/TaskDetailModal'),
);
// const TaskCenterItem = lazy(() => import('@/pages/Marketing/TaskCenter/Item'));
const TaskCenterItem = lazy(() => import('@/pages/Marketing/TaskCenter/Edit'));
// 物流补贴
const MarketingLogistics = lazy(() => import('@/pages/Marketing/Logistics'));
const MarketingLogisticsAdd = lazy(() => import('@/pages/Marketing/Logistics/Add'));
const MarketingLogisticsEdit = lazy(() => import('@/pages/Marketing/Logistics/Edit'));
const MarketingLogisticsCopy = lazy(() => import('@/pages/Marketing/Logistics/Copy'));
// 营销 - 平台券
const PlatformCoupon = lazy(() => import('@/pages/Marketing/PlatformCoupon/List'));
const AddPlatformCoupon = lazy(() => import('@/pages/Marketing/PlatformCoupon/Add'));
const LaunchManage = lazy(() => import('@/pages/Marketing/LaunchManage/List'));
const AddLaunchManage = lazy(() => import('@/pages/Marketing/LaunchManage/Add'));
// 营销 - 返利充值
const OftenUse = lazy(() => import('@/pages/Marketing/OftenUse/OftenUse'));
// 营销 - 满减活动
const FullReduction = lazy(() => import('@/pages/Marketing/FullReduction/index'));
const FullReductionAdd = lazy(() => import('@/pages/Marketing/FullReduction/add'));
const DataComment = lazy(() => import('@/pages/Marketing/Advice/Comment'));
const OrderComment = lazy(() => import('@/pages/Marketing/Advice/OrderComment'));
const DataCommentDetail = lazy(() => import('@/pages/Marketing/Advice/Comment/Detail'));
// 营销-评价-意见管理
const Advice = lazy(() => import('@/pages/Marketing/Advice/Advice'));
const ShowAdvice = lazy(() => import('@/pages/Marketing/Advice/Advice/ShowDetail'));
// 营销-评价-星愿管理
const WishManage = lazy(() => import('@/pages/Marketing/Wish/WishManage/index'));
const AssistManage = lazy(() => import('@/pages/Marketing/Wish/AssistManage/index'));
// 权限
const PrivilegeList = lazy(() => import('@/pages/Privilege/Role/List'));
const PrivilegeManage = lazy(() => import('@/pages/Privilege/Role/ManageRole'));
const PrivilegeActionRole = lazy(() => import('@/pages/Privilege/Role/ActionRole'));
const PrivilegeAccountList = lazy(() => import('@/pages/Privilege/AccountManage/List'));
const PrivilegeAccountEdit = lazy(() => import('@/pages/Privilege/AccountManage/Edit'));
const PrivilegeAuthPoint = lazy(() => import('@/pages/Privilege/AuthPoint/AuthPoint'));
const AddOrEditActionPermission = lazy(
  () => import('@/pages/Privilege/AuthPoint/AddOrEditActionPermission'),
);
const AddOrEditFormPermission = lazy(
  () => import('@/pages/Privilege/AuthPoint/AddOrEditDataPermission'),
);
const PermissionRole = lazy(() => import('@/pages/Privilege/AuthPoint/Role'));
const MenuBind = lazy(() => import('@/pages/Privilege/MenuBind/BindMenu'));
const PostManagement = lazy(() => import('@/pages/Privilege/PostManagement'));
// 财务
// const FinanceSpecialList = lazy(() => import('@/pages/Finance/SpecialList'));
const FinanceAdvanceFunds = lazy(() => import('@/pages/Finance/AdvanceFunds/index'));
const FinanceAdvanceFundsForecast = lazy(
  () => import('@/pages/Finance/AdvanceFundsForecast/indexForecast'),
);

const FinanceAdvanceFundsForShop = lazy(() => import('@/pages/Finance/AdvanceFunds/shopList'));
const FinanceAdvanceFundsForShopForecast = lazy(
  () => import('@/pages/Finance/AdvanceFundsForecast/shopListForecast'),
);

const FinanceDealOrder = lazy(() => import('@/pages/Finance/DealOrder/index'));
const FinanceAddEditStencil = lazy(
  () => import('@/pages/Finance/DealOrder/Stencil/AddEditStencil/AddEditStencil'),
);
const FinanceAccountManage = lazy(() => import('@/pages/Finance/AccountManage'));
const FinanceAccountDetail = lazy(() => import('@/pages/Finance/AccountManage/detail'));
const FinanceSettlementAccountManage = lazy(
  () => import('@/pages/Finance/SettlementAccountManage'),
);
const FinanceCapitalDivide = lazy(() => import('@/pages/Finance/CapitalDivide'));
const FinanceMerchantReconciliation = lazy(() => import('@/pages/Finance/MerchantReconciliation'));
const FinanceEnterpriseCollection = lazy(() => import('@/pages/Finance/EnterpriseCollection'));

const FinanceMonthlySummary = lazy(
  () => import('@/pages/Finance/MonthlyManage/MonthlySummary/index'),
);
const FinanceStoredMange = lazy(() => import('@/pages/Finance/MonthlyManage/StoredMange/index'));

const FinanceManageReportIncome = lazy(() => import('@/pages/Finance/ManageReport/Income/index'));
const FinanceIncomeDetailSaas = lazy(
  () => import('@/pages/Finance/ManageReport/Income/Detail/Saas/index'),
);
const FinanceIncomeDetailMain = lazy(
  () => import('@/pages/Finance/ManageReport/Income/Detail/Main/index'),
);

const FinanceManageReportPayin = lazy(() => import('@/pages/Finance/ManageReport/Payin/index'));
// const /finance/manageReport/payin/detail/
const FinancePayInDetail = lazy(() => import('@/pages/Finance/ManageReport/Payin/Detail/index'));

// 财务-账单管理-手动分账
const ManualSplitAccount = lazy(() => import('@/pages/Finance/ManualSplitAccount'));

const ChargeSearchList = lazy(() => import('@/pages/Finance/Charge/ChargeSearch/index'));
const ChargeSheetList = lazy(() => import('@/pages/Finance/Charge/ChargeSheet/index'));
const FinanceOfflineCost = lazy(() => import('@/pages/Finance/OfflineCost/index'));
const DataOverview = lazy(() => import('@/pages/Data/Overview'));
const DataExport = lazy(() => import('@/pages/Data/Export'));
const DataDefinition = lazy(() => import('@/pages/Data/Definition'));
const DataCustomerGroup = lazy(() => import('@/pages/Data/CustomerGroup'));
const DataNormMange = lazy(() => import('@/pages/Data/DataNormMange'));
const ManageReport = lazy(() => import('@/pages/Data/ManageReport'));
const DataCoreData = lazy(() => import('@/pages/Data/CoreData'));
const DataDaily = lazy(() => import('@/pages/Data/Daily'));
const DataKpi = lazy(() => import('@/pages/Data/Kpi'));

// 设置
// const SettingsInfo = lazy(() => import('@/pages/Settings/Info'));
// const SettingsAuth = lazy(() => import('@/pages/Settings/Auth'));
// const SettingsAuthMsg = lazy(() => import('@/pages/Settings/Auth/Msg'));
const SettingsBalance = lazy(() => import('@/pages/Settings/Balance'));
const SettingsBalanceManage = lazy(() => import('@/pages/Settings/BalanceManage'));
const SettingsGetCash = lazy(() => import('@/pages/Settings/BalanceManage/GetCash'));

// 营运商圈
const OperationBusiness = lazy(() => import('@/pages/Operation/Business/Business'));
const OperationPickMeal = lazy(() => import('@/pages/Operation/PickMeal/index'));
const OperationPickMealForm = lazy(
  () => import('@/pages/Operation/PickMeal/components/addPickMealForm'),
);
const OperationBusinessMap = lazy(() => import('@/pages/Operation/Business/MapPage'));
const ScheduleRecordPage = lazy(() => import('@/pages/Operation/Business/MapPage/ScheduleRecord'));
const OperationReceptionist = lazy(() => import('@/pages/Operation/Receptionist'));
const OperationDeliveryUnit = lazy(() => import('@/pages/Operation/DeliveryUnit'));
const AddOperationDeliveryUnit = lazy(() => import('@/pages/Operation/DeliveryUnit/Add'));
const OperationDeliveryUnitDetail = lazy(() => import('@/pages/Operation/DeliveryUnit/Detail'));
const OperationReceptionistAdd = lazy(
  () => import('@/pages/Operation/Receptionist/StaffAddOrEdit'),
);
const GroupAddressManage = lazy(() => import('@/pages/Operation/GroupAddressManage/index'));
const OperationOrderRemind = lazy(() => import('@/pages/Operation/OrderRemind/index'));
const OperationAssignee = lazy(() => import('@/pages/Operation/Assignee/index'));
const OperationDevice = lazy(() => import('@/pages/Operation/DeviceManage/index'));

// 物流
const OperationBusinessGroup = lazy(() => import('@/pages/Operation/BusinessGroup/index'));
const LogisticsGather = lazy(() => import('@/pages/LogisticsManage/LogisticsGather/index'));
const LogisticsOrder = lazy(() => import('@/pages/LogisticsManage/LogisticsOrder/index'));
const LogisticsDispatch = lazy(() => import('@/pages/LogisticsManage/LogisticsDispatch/index'));
const LogisticsRoute = lazy(() => import('@/pages/LogisticsManage/LogisticsRoute/index'));
const LogisticsPath = lazy(() => import('@/pages/LogisticsManage/LogisticsPath/index'));
const LogisticsSettings = lazy(() => import('@/pages/Operation/Business/LogisticsSettings/index'));
const LogisticsSettingsAddOrEdit = lazy(
  () => import('@/pages/Operation/Business/addOrEditLogistics/index'),
);
const LogisticsTransferPoint = lazy(
  () => import('@/pages/LogisticsManage/LogisticsTransferPoint/index'),
);
const LogisticsGuide = lazy(() => import('@/pages/LogisticsManage/Guide/index'));
const SalaryManagement = lazy(() => import('@/pages/LogisticsManage/Salary'));
const SalaryDetail = lazy(() => import('@/pages/LogisticsManage/Salary/SettleReport/Detail'));
const DeliveryDetail = lazy(
  () => import('@/pages/LogisticsManage/Salary/SettleReport/DeliveryDetail'),
);
const DeliveryOrderDetail = lazy(
  () => import('@/pages/LogisticsManage/Salary/SettleReport/DeliveryOrderDetail'),
);
const LogisticsAccrualType = lazy(() => import('@/pages/LogisticsManage/LogisticsAccrualType'));
const LogisticsAccrualTypeAdd = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualType/Add'),
);
const LogisticsAccrualTypeEdit = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualType/Edit'),
);
const LogisticsAccrualTypeDetail = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualType/Detail'),
);

const LogisticsAccrualRule = lazy(() => import('@/pages/LogisticsManage/LogisticsAccrualRule'));
const LogisticsAccrualRuleAdd = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualRule/Add'),
);
const LogisticsAccrualRuleEdit = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualRule/Edit'),
);
const LogisticsAccrualRuleDetail = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualRule/Detail'),
);
const LogisticsAccrualRuleAudit = lazy(
  () => import('@/pages/LogisticsManage/LogisticsAccrualRule/Audit'),
);
const ScheduleManage = lazy(() => import('@/pages/LogisticsManage/Schedule/index'));
const SchedelArrange = lazy(() => import('@/pages/LogisticsManage/Schedule/SchedelArrange'));
const ArrangeOverview = lazy(() => import('@/pages/LogisticsManage/Schedule/ArrangeOverview'));
const JoinManageCity = lazy(() => import('@/pages/LogisticsManage/JoinManage/JoinManageCity'));
const JoinManageCategory = lazy(
  () => import('@/pages/LogisticsManage/JoinManage/JoinManageCategory'),
);

const OperationNotice = lazy(() => import('@/pages/Operation/Notice/index'));
const OperationNoticeItem = lazy(() => import('@/pages/Operation/Notice/item'));
const OperationBusinessRule = lazy(
  () => import('@/pages/Operation/Business/MapPage/addOrEditRule'),
);
const TimeMachine = lazy(() => import('@/pages/LogisticsManage/TimeMachine'));

// 账单管理
const BillOrderList = lazy(() => import('@/pages/Bill/OrderList'));
// const InvoiceList = lazy(() => import('@/pages/Bill/'));
const Invoice = lazy(() => import('@/pages/Finance/Invoice'));
const BillEnterprise = lazy(() => import('@/pages/BillEnterprise/index'));
const BillMerchant = lazy(() => import('@/pages/BillMerchant'));
const PhysicalCard = lazy(() => import('@/pages/Bill/PhysicalCard'));

// 圈长管理
const ChiefList = lazy(() => import('@/pages/Chief/ChiefList'));
const ChiefDetail = lazy(() => import('@/pages/Chief/ChiefList/detail'));
const ChiefCustomerManage = lazy(() => import('@/pages/Chief/ChiefCustomerManage/index'));
const ChiefGroupInfo = lazy(() => import('@/pages/Chief/ChiefCustomerManage/groupInfo'));
const CustomerUsermanage = lazy(() => import('@/pages/Chief/ChiefCustomerManage/userManage'));
const ChiefActivityManage = lazy(() => import('@/pages/Chief/ChiefActivityManage/index'));
const ChiefActivityAdd = lazy(() => import('@/pages/Chief/ChiefActivityManage/add'));
const ChiefBenefitManage = lazy(() => import('@/pages/Chief/ChiefBenefitManage/index'));
const ConfigurationCenter = lazy(() => import('@/pages/Chief/ConfigurationCenter/index'));
const ChatManage = lazy(() => import('@/pages/Chief/ChatManage/index'));
const ChatManageDetail = lazy(() => import('@/pages/Chief/ChatManage/detail'));

// 环保
const EnvironmentalRule = lazy(() => import('@/pages/Environmental/Rule'));
const EnvironmentalShopManage = lazy(() => import('@/pages/Environmental/ShopManage'));
const EnvironmentalDataManage = lazy(() => import('@/pages/Environmental/DataManage'));

// 配置
const PrintTemplate = lazy(() => import('@/pages/Configure/PrintTemplate'));
const GuideManage = lazy(() => import('@/pages/Configure/MessageManage/Guide'));
const GuideManageDetail = lazy(() => import('@/pages/Configure/MessageManage/Guide/Detail'));
const NoticeManage = lazy(() => import('@/pages/Configure/MessageManage/Notice'));
const NoticeAdd = lazy(() => import('@/pages/Configure/MessageManage/Notice/add'));
const RegionManage = lazy(() => import('@/pages/Configure/RegionManage/Region'));
const AreaManage = lazy(() => import('@/pages/Configure/RegionManage/Area'));
const TargetSelect = lazy(() => import('@/pages/Configure/RegionManage/TargetSelect'));

// 结算
const CheckBill = lazy(() => import('@/pages/Settle/CheckBill'));
const Management = lazy(() => import('@/pages/Settle/Management'));
const ManagementRouter = lazy(() => import('@/pages/Settle/ManagementRouter'));
const CheckBillDetail = lazy(() => import('@/pages/Settle/CheckBillDetail'));
const SettleAccount = lazy(() => import('@/pages/Settle/SettleAccount'));
const MerchantNumManage = lazy(() => import('@/pages/Settle/Management/MerchantNumManage'));

// 商品
const MenuManage = lazy(() => import('@/pages/Goods/MenuManage'));
const MenuManageDetail = lazy(() => import('@/pages/Goods/MenuManage/detail'));
const FoodLibrary = lazy(() => import('@/pages/Goods/FoodLibrary/index'));
const WelfareGoods = lazy(() => import('@/pages/Goods/WelfareGoods'));

// 用户
const UserInfo = lazy(() => import('@/pages/User/UserInfo/index'));
const UserInfoDetail = lazy(() => import('@/pages/User/UserInfo/detail'));
const UserOperate = lazy(() => import('@/pages/User/UserOperate/index'));
const UserOperateDetail = lazy(() => import('@/pages/User/UserOperate/detail'));
// 消息管理
const ShortMsg = lazy(() => import('@/pages/Message/ShortMsg/index'));
const ShortMsgDetail = lazy(() => import('@/pages/Message/ShortMsg/detail'));
const PushRecord = lazy(() => import('@/pages/Message/PushRecord/index'));
const RetryConfiguration = lazy(() => import('@/pages/Message/RetryConfiguration/index'));
const MessageTemplate = lazy(() => import('@/pages/Message/MessageTemplate'));
// 商户
const MerchantManage = lazy(() => import('@/pages/Merchant/Manage'));
//  食堂管理
const MerchantCanteen = lazy(() => import('@/pages/Merchant/Canteen'));
const MerchantCanteenEdite = lazy(() => import('@/pages/Merchant/Canteen/Edite'));
// 商城装修
const ShoppingmallRenovation = lazy(() => import('@/pages/Shoppingmall/Renovation'));
const ShoppingmallRenovationAdd = lazy(() => import('@/pages/Shoppingmall/Renovation/add'));
const ShoppingmallBanner = lazy(() => import('@/pages/Shoppingmall/Banner'));
const ShoppingmallAddEditBanner = lazy(
  () => import('@/pages/Shoppingmall/Banner/AddEditBanner/AddEditBanner'),
);

// 日志系统
const logOperation = lazy(() => import('@/pages/Log/LogOperation'));
// 合作伙伴
const saasAgentManage = lazy(() => import('@/pages/SaasAgent/Manage'));
const ActionSaasAgent = lazy(
  () => import('@/pages/SaasAgent/Manage/ActionSaasAgent/ActionSaasAgent'),
);

const saasAgentManageAdd = lazy(() => import('@/pages/SaasAgent/Manage/Add'));
const saasAgentManageContractManageAdd = lazy(
  () => import('@/pages/SaasAgent/Manage/Detail/ContractManageList/add'),
);
const saasAgentManageDetail = lazy(() => import('@/pages/SaasAgent/Manage/Detail'));

const saasAgentPlatform = lazy(() => import('@/pages/SaasAgent/Platform'));
const saasAgentBill = lazy(() => import('@/pages/SaasAgent/Bill'));

const TransferAccount = lazy(
  () => import('@/pages/SaasAgent/Platform/TransferAccount/TransferAccount'),
);

const WithdrawDeposit = lazy(
  () => import('@/pages/SaasAgent/Platform/WithdrawDeposit/WithdrawDeposit'),
);

const SchoolMange = lazy(() => import('@/pages/School/SchoolMange'));
const CourseAddEdit = lazy(() => import('@/pages/School/SchoolMange/Course/CourseAddEdit'));
const SchoolCenter = lazy(() => import('@/pages/School/SchoolCenter'));
const CourseDetail = lazy(() => import('@/pages/School/SchoolCenter/CourseDetail'));

// 路由列表
// TIP: 若页面存在「餐饮版」，则在配置中添加 `food` 字段即可
const routes = [
  // 账户
  { path: '/account', component: Account, show: true },
  // 欢迎
  { path: '/welcome', component: Welcome },
  { path: '/', component: Welcome },

  // 业务
  // 业务--商户管理--商户管理
  // { path: 'SHOP_WITHDRAW_QUERY_STATUS_BMS', component: BusinessShopMerchant },
  // 业务--商户管理--门店资质
  { path: '/merchant/shop/qualifications', component: ShopLicense },
  { path: '/merchant/shop/qualifications/item/:licenseId', component: ShopLicenseItem },
  {
    path: '/merchant/shop/qualifications/restaurant/:restaurantLicenseId',
    component: ShopLicenseResraurant,
  },
  {
    path: '/merchant/shop/qualifications/detail/:licenseId/:restaurantLicenseId',
    component: ShopLicenseDetail,
  },
  {
    path: '/merchant/shop/qualifications/store/:licenseId/:restaurantLicenseId',
    component: ShopLicenseStore,
  },
  {
    path: '/operation/complaint',
    component: ShopComplaint,
  },
  {
    path: '/merchant/snackcabinet',
    component: SnackCabinet,
  },
  {
    path: '/merchant/snackcabinet/:type/:id?',
    component: SnackCabinetDetail,
  },
  // 企业管理
  { path: '/company/manage/manage', component: Enterprise },
  { path: '/company/manage/manage/research/:id?', component: Research },
  { path: '/company/useraccount', component: UserAccount },
  {
    path: '/company/manage/manage/edit',
    component: EnterpriseEdit,
  },
  //  硬件-硬件管理
  { path: '/hardware/manage', component: HardwareManage },
  { path: '/hardware/manage/add', component: HardwareManageEdite },
  { path: '/hardware/manage/edite/:id', component: HardwareManageEdite },
  //  硬件-设备绑定管理
  { path: '/hardware/binding', component: HardwareBinding },
  { path: '/hardware/binding/add', component: HardwareBindingEdite },
  { path: '/hardware/binding/edite/:id', component: HardwareBindingEdite },
  { path: '/hardware/binding/copy/:id', component: HardwareBindingEdite },
  //  硬件-广告管理
  { path: '/hardware/advertisement', component: Advertisement },
  { path: '/hardware/advertisement/add', component: AdvertisementEdite },
  { path: '/hardware/advertisement/:operation/:id', component: AdvertisementEdite },
  // 店铺
  { path: '/company/allowance', component: Allowance },
  { path: '/merchant/shop/manage', component: ShopPolymerManage },
  { path: '/merchant/shop/manage/hardware-list', component: ShopHardWareList },
  { path: '/merchant/shop/manage/bind-hardware', component: ShopBindHardWare },
  { path: '/merchant/shop/score', component: ShopScore },
  {
    path: '/merchant/shop/manage/max-production-detail/:shopId/:subShopId/:agentName?',
    component: ProductionItem,
  },
  { path: '/shop/agent', component: ShopAgent },
  { path: '/shop/agent/logisticssettle/:shopId', component: ShopAgentSettle },
  { path: '/shop/agent/logisticssettle/add/:shopId', component: ShopAgentRuleAdd },
  { path: '/shop/agent/logisticssettle/edit/:shopId', component: ShopAgentRuleEdit },
  // 商铺标签页
  { path: '/merchant/brand', component: ShopBrand },
  { path: '/merchant/brand/add', component: ShopBrandItem },
  { path: '/merchant/brand/view/:id', component: ShopBrandItem },
  { path: '/merchant/brand/edit/:id', component: ShopBrandItem },

  // 新增订单
  { path: '/order/optorder/modifyOrder/:id', component: OptOrderExpress },
  { path: '/order/optorder', component: OptOrderList },
  { path: '/order/optorder/detail', component: OptOrderDetail },
  { path: '/order/cardorder', component: CardOrder },
  { path: '/order/tsorder', component: TsOrder },
  { path: '/order/tsorder/detail/:orderId/:shopId/:subShopId', component: TsOrderDetail },
  { path: '/order/supplement/', component: SupplementOrder },
  { path: '/order/shoptopayorder/', component: ShopToPayOrder },
  { path: '/order/shoptopayorder/detail/:id', component: ShopToPayOrderDetail },
  { path: '/order/supplement/:type/:id?/:saasAgentId?', component: SupplementOrderItem },
  { path: '/order/liveMealStatistics/', component: LiveMealStatistics },
  { path: '/order/activityorder', component: ActivityOrder },
  { path: '/order/addOrder', component: AddOrder },
  //  订单管理-售后订单
  { path: '/order/after', component: AfterOrder },

  // 商户

  { path: '/merchant/canteen', component: MerchantCanteen },
  { path: '/merchant/canteen/add', component: MerchantCanteenEdite },
  { path: '/merchant/canteen/edite/:id', component: MerchantCanteenEdite },
  // { path: '/customer/orderremind', component: OrderRemind },
  { path: '/merchant/customerAccount', component: CustomerAccount },
  { path: '/merchant/customerAccount/showdetail/:id', component: CustomerAccountDetail },
  { path: '/merchant/customerAbutment', component: CustomerAbutment },
  { path: '/merchant/manage/manage', component: MerchantMange },
  { path: '/merchant/manage/manage/edit', component: MerchantEdit },
  { path: '/merchant/manage/manage/edit/contractform', component: ContractInfoForm },
  { path: '/merchant/manage/manage/edit/newcontractform', component: NewContractInfoForm },
  { path: '/merchant/manage/manage/edit/historycontractform', component: HistoryContractInfoForm },
  { path: '/merchant/shop/manage', component: MerchantShop },
  { path: '/merchant/shop/manage/patrol/:id?', component: MerchantShopPatrol },
  { path: '/company/manage/enterprise', component: EnterpriseManage },
  { path: '/company/manage/enterprise/edit', component: EnterpriseManageEdit },
  { path: '/company/manage/enterprise/edit/add', component: EnterpriseAddNewContract },
  { path: '/merchant/valuation', component: MerchantValuation },
  { path: '/merchant/valuation/add', component: MerchantValuationAdd },
  // 营销
  { path: '/marketing/tool', component: MarketingManage },
  // 营销-评价
  { path: '/advice/manage', component: Advice },
  { path: '/advice/manage/showdetail/:id', component: ShowAdvice },
  // 营销-星愿
  { path: '/merchant/wish/advice', component: WishManage },
  { path: '/merchant/wish/assist', component: AssistManage },
  // 返利充值
  { path: '/marketing/often-use', component: OftenUse },
  // 营销 - 返利记录
  { path: '/marketing/money-record', component: MoneyRecord },
  { path: '/marketing/record-manage', component: RecordManage },
  { path: '/marketing/record-manage/add', component: RecordManageAdd },
  { path: '/marketing/record-manage/edit/:id', component: RecordManageAdd },
  // 营销 - 红包活动
  { path: '/marketing/redpacket-manage', component: RedPacketManage },
  { path: '/marketing/redpacket-manage/add', component: RedPacketManageAdd },
  { path: '/marketing/redpacket-manage/edittarget', component: RedPacketManageEditTarget },
  // 新人福利
  { path: '/marketing/tool/new-welfare', component: NewWelfareList },
  { path: '/marketing/tool/new-welfare/add', component: NewWelfareAdd },
  // 任务中心
  { path: '/marketing/tool/task-center', component: TaskCenterList },
  {
    path: '/marketing/tool/task-center/detail/:jobId/:isChild',
    component: TaskCenterDetail,
  },
  { path: '/marketing/tool/task-center/add', component: TaskCenterItem },
  { path: '/marketing/tool/task-center/edit/:id', component: TaskCenterItem },
  // 物流补贴
  { path: '/marketing/logisticssubsidies', component: MarketingLogistics },
  { path: '/marketing/logisticssubsidies/add', component: MarketingLogisticsAdd },
  {
    path: '/marketing/logisticssubsidies/edit/:subsidiesId/:isDetail?',
    component: MarketingLogisticsEdit,
  },
  {
    path: '/marketing/logisticssubsidies/copy/:subsidiesId',
    component: MarketingLogisticsCopy,
  },

  // 平台券
  { path: '/marketing/platform-coupon', component: PlatformCoupon },
  {
    path: '/marketing/platform-coupon/addoredit/:addEditType?/:couponId?',
    component: AddPlatformCoupon,
  },
  { path: '/marketing/launch-manage', component: LaunchManage },
  { path: '/marketing/launch-manage/addoredit', component: AddLaunchManage },

  // 满减
  { path: '/marketing/full-reduction', component: FullReduction },
  { path: '/marketing/full-reduction/add', component: FullReductionAdd },
  // 广告

  { path: '/user/advertisement', component: ShopAdvertisement },
  { path: '/user/advertisement/add', component: ShopAdvertisementItem },
  { path: '/user/advertisement/view/:id', component: ShopAdvertisementItem },
  { path: '/user/advertisement/edit/:id', component: ShopAdvertisementItem },
  { path: '/user/advertisement/copy/:id', component: ShopAdvertisementItem },
  { path: '/advice/comment', component: DataComment },
  { path: '/advice/comment/detail/:shopId/:subShopId', component: DataCommentDetail },
  { path: '/advice/order-comment', component: OrderComment },

  // 权限
  { path: '/privilege/role', component: PrivilegeList },
  { path: '/privilege/role/managerole', component: PrivilegeManage },
  { path: '/privilege/role/action/:type/:plantform?/:roleId?', component: PrivilegeActionRole },
  { path: '/privilege/account', component: PrivilegeAccountList },
  { path: '/privilege/account/edit', component: PrivilegeAccountEdit },
  { path: '/privilege/auth-point', component: PrivilegeAuthPoint },
  {
    path: '/privilege/auth-point/addOrEditActionPermission/:type/:platformCode/:actionId?',
    component: AddOrEditActionPermission,
  },
  {
    path: '/privilege/auth-point/addOrEditFormPermission/:type/:platformCode/:dataId?',
    component: AddOrEditFormPermission,
  },
  {
    path: '/privilege/auth-point/role/:permissionId?',
    component: PermissionRole,
  },
  { path: '/privilege/menu-bind', component: MenuBind },
  { path: '/privilege/post-management', component: PostManagement },
  // 财务
  // { path: '/finance/speciallist', component: FinanceSpecialList },

  { path: '/finance/monthlyManage/creditList', component: ChargeSearchList }, // 企业充值下的 授信查询
  { path: '/finance/billmanage/sheet', component: ChargeSheetList }, // 企业充值下的 充值报表
  { path: '/finance/monthlyManage/monthlySummary', component: FinanceMonthlySummary }, // 月结汇总
  { path: '/finance/monthlyManage/stored', component: FinanceStoredMange }, // 月结汇总

  // { path: '/finance/manage/advancefunds', component: FinanceAdvanceFunds },
  { path: '/finance/manage/advancefundsforecast', component: FinanceAdvanceFundsForecast },
  { path: '/finance/manage/account-manage', component: FinanceAccountManage },
  {
    path: '/finance/manage/account-detail/:accountId/:accountName',
    component: FinanceAccountDetail,
  },
  { path: '/settle/settlement-account-manage', component: FinanceSettlementAccountManage },
  { path: '/finance/manage/capital-divide', component: FinanceCapitalDivide },
  { path: '/finance/adjustment/merchant-reconciliation', component: FinanceMerchantReconciliation },
  // { path: '/finance/manage/advancefunds/advanceforshop', component: FinanceAdvanceFundsForShop },
  {
    path: '/finance/manage/advancefundsforecast/advanceforshopforecast',
    component: FinanceAdvanceFundsForShopForecast,
  },
  { path: '/finance/billmanage/deal-order/:tab?', component: FinanceDealOrder },
  { path: '/finance/billmanage/stencil/:type/:id?', component: FinanceAddEditStencil },
  { path: '/finance/billmanage/enterprise-collection', component: FinanceEnterpriseCollection },
  { path: '/finance/billmanage/offline-cost', component: FinanceOfflineCost },
  { path: '/finance/billmanage/manual-split-account', component: ManualSplitAccount },

  // 数据
  { path: '/data/overview', component: DataOverview },
  { path: '/data/export', component: DataExport }, // 数据导出
  { path: '/data/definition', component: DataDefinition }, // 数据定义
  { path: '/data/customergroup', component: DataCustomerGroup },
  { path: '/data/manageReport', component: ManageReport }, //管理报表
  { path: '/data/coredata', component: DataCoreData }, // 核心数据
  { path: '/data/dataNorm', component: DataNormMange }, // 数据库指标管理
  { path: '/data/daily', component: DataDaily }, // 业务日报
  { path: '/data/kpi', component: DataKpi }, // 业绩目标

  // 设置
  // { path: '/settings/info', component: SettingsInfo },
  // { path: '/settings/auth', component: SettingsAuth },
  // { path: '/settings/auth/msg', component: SettingsAuthMsg },
  { path: '/finance/manage/balance', component: SettingsBalance },
  { path: '/finance/manage/balancemanage', component: SettingsBalanceManage },
  {
    path: '/finance/manage/balancemanage/getcash',
    component: SettingsGetCash,
  },

  // 营运商圈
  { path: '/user/order-remind', component: OperationOrderRemind },
  { path: '/operation/business', component: OperationBusiness },
  { path: '/operation/pickmeal', component: OperationPickMeal },
  { path: '/operation/pickmeal/add', component: OperationPickMealForm },
  { path: '/operation/pickmeal/edit/:groupId', component: OperationPickMealForm },
  { path: '/operation/business/map', component: OperationBusinessMap },
  { path: '/operation/business/map/schedulerecord', component: ScheduleRecordPage },
  {
    path: '/operation/business/addoredit/:type/:cbdId/:ruleId?/:companyId?/:companyName?',
    component: OperationBusinessRule,
  },
  { path: '/logistics/receptionist', component: OperationReceptionist },
  { path: '/logistics/delivery', component: OperationDeliveryUnit },
  { path: '/logistics/delivery/add', component: AddOperationDeliveryUnit },
  {
    path: '/logistics/delivery/detail/:distributionUnitId?',
    component: OperationDeliveryUnitDetail,
  },
  {
    path: '/logistics/receptionist/addoredit/:addEditType/:staffType/:employeeId?',
    component: OperationReceptionistAdd,
  },
  { path: '/operation/groupaddressmanage', component: GroupAddressManage },
  { path: '/operation/assignee', component: OperationAssignee },
  { path: '/operation/device', component: OperationDevice },

  { path: '/logistics/manage/gather', component: LogisticsGather },
  { path: '/logistics/manage/order', component: LogisticsOrder },
  { path: '/logistics/control/dispatch', component: LogisticsDispatch },
  { path: '/logistics/control/route', component: LogisticsRoute },
  { path: '/logistics/control/path', component: LogisticsPath },

  //物流设置相关页面已全部移动至新的配送单元页面
  {
    path: '/operation/business/logisticsSettings/:cbdId/:defaultMode?',
    component: LogisticsSettings,
  },
  {
    path: '/operation/business/logisticsSettingsDetail/:cbdId?/:ruleId?',
    component: LogisticsSettingsAddOrEdit,
  },
  { path: '/logistics/timeMachine', component: TimeMachine },

  { path: '/logistics/schedule', component: ScheduleManage },
  { path: '/logistics/schedule/arrange', component: SchedelArrange },
  { path: '/logistics/schedule/overview', component: ArrangeOverview },

  { path: '/logistics/source/businessgroup', component: OperationBusinessGroup },
  { path: '/logistics/source/transfer', component: LogisticsTransferPoint },
  { path: '/logistics/salarymanage', component: SalaryManagement },
  { path: '/logistics/salarymanage/detail', component: SalaryDetail },
  { path: '/logistics/salarymanage/deliveryDetail', component: DeliveryDetail },
  { path: '/logistics/salarymanage/DeliveryOrderDetail', component: DeliveryOrderDetail },
  { path: '/logistics/accrual/type', component: LogisticsAccrualType },
  { path: '/logistics/accrual/type/add', component: LogisticsAccrualTypeAdd },
  { path: '/logistics/accrual/type/edit/:id', component: LogisticsAccrualTypeEdit },
  { path: '/logistics/accrual/type/detail/:id', component: LogisticsAccrualTypeDetail },
  { path: '/logistics/accrual/rule', component: LogisticsAccrualRule },
  { path: '/logistics/accrual/rule/add/:tabKey/:workType', component: LogisticsAccrualRuleAdd },
  {
    path: '/logistics/accrual/rule/edit/:tabKey/:id/:workType',
    component: LogisticsAccrualRuleEdit,
  },
  {
    path: '/logistics/accrual/rule/detail/:tabKey/:id/:workType',
    component: LogisticsAccrualRuleDetail,
  },
  {
    path: '/logistics/accrual/rule/audit/:tabKey/:id/:workType',
    component: LogisticsAccrualRuleAudit,
  },
  // 物流-对接管理-城市管理
  {
    path: '/logistics/jointmanage/city',
    component: JoinManageCity,
  },
  // 物流-对接管理-品类管理
  {
    path: '/logistics/jointmanage/category',
    component: JoinManageCategory,
  },

  { path: '/logistics/guide', component: LogisticsGuide },
  // 账单管理
  { path: '/finance/billmanage/order', component: BillOrderList },
  { path: '/finance/invoice', component: Invoice },
  { path: '/finance/billmanage/billenterprise', component: BillEnterprise },
  { path: '/finance/billmanage/merchant', component: BillMerchant },
  { path: '/finance/manage/physicalcard', component: PhysicalCard },
  { path: '/finance/manageReport/income', component: FinanceManageReportIncome },
  { path: '/finance/manageReport/detail/main/:month?', component: FinanceIncomeDetailMain },
  { path: '/finance/manageReport/detail/saas/:month?', component: FinanceIncomeDetailSaas },
  { path: '/finance/manageReport/payin', component: FinanceManageReportPayin },
  { path: '/finance/manageReport/payin/detail/:month?', component: FinancePayInDetail },

  // 团长管理
  { path: '/chief/list', component: ChiefList },
  { path: '/chief/list/detail', component: ChiefDetail },
  { path: '/chief/customermanage', component: ChiefCustomerManage },
  { path: '/chief/customermanage/info/:groupId', component: ChiefGroupInfo },
  { path: '/chief/activitymanage', component: ChiefActivityManage },
  { path: '/chief/activitymanage/add', component: ChiefActivityAdd },
  { path: '/chief/benefitmanage', component: ChiefBenefitManage },
  { path: '/chief/configurationcenter', component: ConfigurationCenter },
  { path: '/chief/customermanage/usermanage', component: CustomerUsermanage },
  { path: '/chief/chatmanage', component: ChatManage },
  { path: '/chief/chatmanage/detail', component: ChatManageDetail },

  // 环保
  { path: '/environmental/rule', component: EnvironmentalRule },
  { path: '/environmental/shopmanage', component: EnvironmentalShopManage },
  { path: '/environmental/datamanage', component: EnvironmentalDataManage },

  // 配置
  { path: '/merchant/printtemplate', component: PrintTemplate },
  { path: '/merchant/notice', component: NoticeManage },
  { path: '/merchant/notice/add', component: NoticeAdd },
  { path: '/merchant/guide', component: GuideManage },
  { path: '/merchant/guide/:type/:docId?', component: GuideManageDetail },
  { path: '/operation/regionmanage/region', component: RegionManage },
  { path: '/operation/regionmanage/area', component: AreaManage },
  { path: '/tool/targetcomponent', component: TargetSelect },

  // 结算
  { path: '/settle/checkbill', component: CheckBill },
  { path: '/settle/management/config', component: Management },
  { path: '/settle/management/router', component: ManagementRouter },
  { path: '/settle/checkbill/detail', component: CheckBillDetail },
  { path: '/settle/account', component: SettleAccount },
  { path: '/settle/merchantnum', component: MerchantNumManage },

  // 商品
  { path: '/goods/menumanage', component: MenuManage },
  { path: '/goods/menumanage/detail', component: MenuManageDetail },
  { path: '/goods/food-library', component: FoodLibrary },
  { path: '/goods/welfare', component: WelfareGoods },
  // 用户
  { path: '/user/userinfo', component: UserInfo },
  { path: '/user/userinfo/detail', component: UserInfoDetail },
  { path: '/user/useroperate', component: UserOperate },
  { path: '/user/useroperate/detail', component: UserOperateDetail },
  { path: '/user/notice', component: OperationNotice },
  { path: '/user/notice/add', component: OperationNoticeItem },
  { path: '/user/notice/edit/:id', component: OperationNoticeItem },

  // 消息管理
  { path: '/message/shortmsg', component: ShortMsg },
  { path: '/message/shortmsg/detail', component: ShortMsgDetail },
  { path: '/message/template', component: MessageTemplate },
  { path: '/message/pushRecord', component: PushRecord },
  { path: '/message/retryConfiguration', component: RetryConfiguration },
  // 商户
  {
    path: '/merchant/manage/manage',
    component: MerchantManage,
  },

  // 商城装修
  {
    path: '/shoppingmall/renovation',
    component: ShoppingmallRenovation,
  },
  {
    path: '/shoppingmall/renovation/add',
    component: ShoppingmallRenovationAdd,
  },
  {
    path: '/shoppingmall/banner',
    component: ShoppingmallBanner,
  },
  {
    path: '/shoppingmall/banner/:type?/:id?',
    component: ShoppingmallAddEditBanner,
  },
  // 日志系统
  {
    path: '/log/operation',
    component: logOperation,
  },
  // 合作伙伴
  {
    path: '/saas-agent/manage',
    component: saasAgentManage,
  },
  {
    path: '/saas-agent/bill',
    component: saasAgentBill,
  },
  // 合作伙伴-功能设置
  {
    path: '/saas-agent/manage/role-action/:saasAgentId',
    component: ActionSaasAgent,
  },
  {
    path: '/saas-agent/manage/add',
    component: saasAgentManageAdd,
  },
  {
    path: '/saas-agent/manage/contract',
    component: saasAgentManageContractManageAdd,
  },
  {
    path: '/saas-agent/manage/detail',
    component: saasAgentManageDetail,
  },
  {
    // 提现
    path: '/saas-agent/platform/withdraw/:pingIds',
    component: WithdrawDeposit,
  },
  {
    // 转账
    path: '/saas-agent/platform/transfer/:pingIds',
    component: TransferAccount,
  },
  {
    path: '/saas-agent/platform',
    component: saasAgentPlatform,
  },

  // 丰食学堂
  {
    path: '/school/manage',
    component: SchoolMange,
  },
  {
    path: '/school/manage/course/:actionType?/:id?',
    component: CourseAddEdit,
  },
  {
    path: '/school/center',
    component: SchoolCenter,
  },
  {
    path: '/school/center/detail/:id?',
    component: CourseDetail,
  },
  // 404
  { path: '*', component: NotFound, show: true },
];

export default routes;
